console.log("reservation.js loaded");

// Fonction de validation pour vérifier que la zone et la période sont sélectionnées
const validateZoneAndPeriod = (form) => {
  // Déterminer quel flux est actif (ETS ou Autre)
  const isEtsFlow = form.querySelector('#form-ets-step-1') && form.querySelector('#form-ets-step-1').classList.contains('flow-selected');
  const isOtherFlow = form.querySelector('#form-other-step-1') && form.querySelector('#form-other-step-1').classList.contains('flow-selected');
  
  // Sélectionner la bonne table selon le flux
  let targetTable = null;
  let tableErrorMessage = null;
  
  if (isEtsFlow) {
    targetTable = form.querySelector(".table_zone");
    tableErrorMessage = form.querySelector(".table_zone .errorMessage");
  } else if (isOtherFlow) {
    targetTable = form.querySelector(".table_zone_2");
    tableErrorMessage = form.querySelector(".table_zone_2 .errorMessage");
  }
  
  // Créer le message d'erreur dans la table si nécessaire
  if (!tableErrorMessage && targetTable) {
    tableErrorMessage = document.createElement("div");
    tableErrorMessage.className = "errorMessage";
    tableErrorMessage.style.color = "#c00816";
    tableErrorMessage.style.fontSize = "14px";
    tableErrorMessage.style.marginTop = "10px";
    tableErrorMessage.style.textAlign = "center";
    targetTable.appendChild(tableErrorMessage);
  }

  
  // Vérifier les périodes sélectionnées dans la table appropriée
  const selectedPeriods = targetTable ? targetTable.querySelectorAll(".periode.selectable.selected") : [];
  
  // Vérifier aussi les champs cachés (fallback)
  const zoneInput = form.querySelector('input[name="zone"]');
  const periodesInput = form.querySelector('input[name="periodes"]');
  const hasZoneValue = zoneInput && zoneInput.value.trim() !== '';
  const hasPeriodesValue = periodesInput && periodesInput.value.trim() !== '';
  
  // Validation : soit des périodes visuellement sélectionnées, soit des valeurs dans les champs cachés
  const isValid = selectedPeriods.length > 0 || (hasZoneValue && hasPeriodesValue);
  
  if (!isValid) {
    // Afficher le message d'erreur dans la table
    if (tableErrorMessage) {
      tableErrorMessage.innerHTML = "Veuillez sélectionner une zone et au moins une période avant d'envoyer le formulaire.";
      tableErrorMessage.style.display = "block";
      tableErrorMessage.focus();

          // Scroll automatiquement le bon conteneur (form-step en desktop, modal/inner-modal en mobile)
         try {
          tableErrorMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } catch (_) {
          // Fallback minimal
          tableErrorMessage.scrollIntoView();
        }
    }

    return false;
  } else {
    // Masquer les messages d'erreur dans la table
    if (tableErrorMessage) {
      tableErrorMessage.innerHTML = "";
      tableErrorMessage.style.display = "none";
    }
    return true;
  }
};

// Gestion des attributs required selon la step courante
const adjustRequiredAttributes = (formEl) => {
  if (!formEl) return;
  const currentStep = formEl.querySelector('.form-step.current');
  const allInputs = formEl.querySelectorAll('input, select, textarea');

  allInputs.forEach((el) => {
    // En mobile, si des steps ont la classe .flow-selected, on considère
    // tous les champs à l'intérieur comme "courants" (visibles)
    const hasFlowSelected = !!formEl.querySelector('.form-step.flow-selected');
    const inFlowSelected = !!el.closest('.flow-selected');
    const isInCurrent = hasFlowSelected ? inFlowSelected : !!(currentStep && currentStep.contains(el));
    const wasRequired = el.hasAttribute('data-was-required');
    const isRequired = el.hasAttribute('required');

    if (isInCurrent) {
      // Restaurer required si nécessaire
      if (wasRequired && !isRequired) {
        el.setAttribute('required', 'required');
        el.removeAttribute('data-was-required');
      }
    } else {
      // Retirer required en dehors de la step courante pour ne pas bloquer le submit natif
      if (isRequired) {
        el.setAttribute('data-was-required', '1');
        el.removeAttribute('required');
      }
    }
  });
};

/**
 * Gestion du formulaire de réservation
 * @param {string} formSelector - Le sélecteur du formulaire à gérer
 */
const handleFormSubmit = (formSelector) => {
  const form = document.querySelector(formSelector);

  if (form) {

    // Ajuster required au chargement
    adjustRequiredAttributes(form);

    // Recalibrer lors des changements de step (après que la classe current ait bougé)
    document.addEventListener(
      'click',
      (e) => {
        if (e.target.closest('.toggle-step')) {
          setTimeout(() => adjustRequiredAttributes(form), 0);
        }
        if (e.target.closest('button[type="submit"]')) {
          // S'assurer que le submit natif ne soit pas bloqué par des champs requis cachés
          adjustRequiredAttributes(form);
          
          // Validation immédiate lors du clic sur le bouton de soumission
          if (!validateZoneAndPeriod(form)) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        }
      },
      true
    );

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      console.log(`Envoi du formulaire ${formSelector}`);

      // Validation : vérifier que la zone et la période sont sélectionnées
      if (!validateZoneAndPeriod(form)) {
        console.log("Validation échouée : zone et période non sélectionnées");
        return; // Empêcher la soumission du formulaire
      }

      // Cibler la step courante pour afficher messages/erreurs et gérer le bon bouton
      const currentStep = form.querySelector('.form-step.current');
      const scopeEl = currentStep || form;

      const message = scopeEl.querySelector('.message') || form.querySelector('.message');
      const validationErrors = scopeEl.querySelector('.validation-errors') || form.querySelector('.validation-errors');
      let btn = (scopeEl.querySelector('button[type="submit"]') || form.querySelector('button[type="submit"]'));

      if (btn) {
        btn.setAttribute('disabled', 'disabled');
        btn.classList.add('running');
      }

      const formData = new FormData(e.target);

      // Normaliser les champs zone/periodes/dates pour éviter les doublons vides entre ETS et Autre
      try {
        const getValueFrom = (selector) => {
          const el = form.querySelector(selector);
          return el ? (el.value || "") : "";
        };

        // Priorité aux valeurs du flux "Autre structure" si présentes
        const zoneAutre = getValueFrom('#form-other-step-1 input[name="zone"]');
        const periodesAutre = getValueFrom('#form-other-step-1 input[name="periodes"]');
        const datesAutre = getValueFrom('#form-other-step-1 input[name="dates"]');

        // Valeurs côté ETS (step deux ETS)
        const zoneEts = getValueFrom('.table_zone ~ input[name="zone"], .table_zone input[name="zone"]');
        const periodesEts = getValueFrom('.table_zone ~ input[name="periodes"], .table_zone input[name="periodes"]');
        const datesEts = getValueFrom('.table_zone ~ input[name="dates"], .table_zone input[name="dates"]');

        const zoneVal = zoneAutre || zoneEts || "";
        const periodesVal = periodesAutre || periodesEts || "";
        const datesVal = datesAutre || datesEts || "";

        // set remplace toutes les occurrences existantes de la clé (évite les champs vides en double)
        formData.set('zone', zoneVal);
        formData.set('periodes', periodesVal);
        formData.set('dates', datesVal);
      } catch (_) {
        // non bloquant
      }

      // Unit_tag CF7 selon l'ID du formulaire
      try {
        const actionUrl = e.target.getAttribute('action') || '';
        const match = actionUrl.match(/contact-form-7\/v1\/contact-forms\/(\d+)\//);
        const formId = match && match[1] ? match[1] : null;
        if (formId === '617') {
          formData.append('_wpcf7_unit_tag', 'wpcf7-p617-p8-01');
        } else if (formId === '618') {
          formData.append('_wpcf7_unit_tag', 'wpcf7-p618-p8-01');
        }
      } catch (_) {
        // non bloquant
      }

      // Fallback au cas où l'ID n'a pas pu être déterminé
      if (!formData.has('_wpcf7_unit_tag')) {
        formData.append('_wpcf7_unit_tag', 'wpcf7-p617-p8-01');
      }

      window
        .fetch(e.target.getAttribute("action"), {
          method: e.target.getAttribute("method"),
          body: formData,
        })
        .then((response) => response.json())
        .then((data) => {
          if (message) {
            message.classList.add('active');
            message.innerHTML = data.message;
          }
          if (btn) {
            btn.classList.remove('running');
          }

          if (data.status === "mail_sent") {
            if (message) message.classList.add('success');

            // Afficher uniquement le message et masquer le contenu du formulaire dans la modale
            try {
              const innerModal = form.closest('.inner-modal');
              const formContainer = form.parentElement; // le <div> englobant le <form>
              if (formContainer && innerModal) {
                formContainer.style.display = 'none';
                // Ajouter un bloc de retour centré avec le message
                const feedback = document.createElement('div');
                feedback.className = 'submission-feedback';
                feedback.style.padding = '24px';
                feedback.style.margin = 'auto';
                feedback.style.textAlign = 'center';
                feedback.style.height = '100%';
                feedback.style.alignContent = 'center';
                feedback.innerHTML = `<div class="message success" style="display:inline-block;max-width:720px; font-size: 18px; font-weight: 600;">${data.message}</div>`;
                innerModal.appendChild(feedback);
              }
            } catch (_) {
              // non bloquant
            }

          } else if (data.status === "validation_failed") {
            if (message) message.classList.add('error');
            if (validationErrors) {
              validationErrors.innerHTML = ""; // Réinitialiser les erreurs précédentes
              data.invalid_fields.forEach((field) => {
                const el = document.createElement('li');
                el.innerHTML = `${field.field}: ${field.message}`;
                validationErrors.appendChild(el);
              });
            }
          } else if (data.status === "mail_failed") {
            if (message) message.classList.add('error');
          } else {
            console.log("Réponse inattendue");
          }
        })
        .catch((error) => {
          console.error(
            `Erreur lors de l’envoi du formulaire ${formSelector}:`,
            error
          );
          if (message) {
            message.classList.add('error');
            message.innerHTML = "Une erreur s'est produite. Veuillez réessayer.";
          }
          if (btn) {
            btn.classList.remove('running');
          }
        })
        .finally(() => {
          if (btn) btn.removeAttribute('disabled');
        });
    });
  }
};

// Appliquer la fonction aux deux formulaires
handleFormSubmit("form#form-reservation");
handleFormSubmit("form#form-autre-structure");



// WEBPACK FOOTER //
// ./scripts/reservation.js